// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Supplies_wrapper__moftV","table":"Supplies_table__13cNU","toolbar":"Supplies_toolbar__3gJv1"};